// extracted by mini-css-extract-plugin
module.exports = {"component":"hubspot-form-multi_component__XiVtt","menu":"hubspot-form-multi_menu__fryrK","tabs":"hubspot-form-multi_tabs__lHbW5","isSurface":"hubspot-form-multi_isSurface__NZpnb"};